import { createColumnHelper } from "@tanstack/react-table";
import { dateFormatter } from "../../../utils/dateFormatter";
const columnHelper = createColumnHelper();

export const cancellationTableColumnsConfig = {
  cancellation: (handleOpenModal, handleCancellationDetail) => [
    columnHelper.accessor("id", {
      header: "ID",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("user_id", {
      header: "User Id",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("ordered_on", {
      header: "Ordered On",
      cell: (info) => dateFormatter(info.getValue()),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("postal_code", {
      header: "PinCode",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("total_amount", {
      header: "Total Amount",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
    columnHelper.display({
      id: "actions__navigate",
      header: <div style={{ textAlign: "center" }}>View Details</div>,
      cell: (props) => (
        <div
          style={{
            display: "flex",
            columnGap: "12px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            style={{
              color: "#C6C6C6",
              fontSize: "12px",
              lineHeight: "12px",
              fontWeight: 400,
              fontFamily: "Poppins, sans",
              padding: "7px 8px",
              borderRadius: "4px",
              border: "1px solid #C6C6C6",
              backgroundColor: "#FFFFFF",
              cursor: "pointer",
            }}
            onClick={() => handleCancellationDetail(props.row.original.id)}
          >
            View Details
          </button>
        </div>
      ),
    }),

    columnHelper.display({
      id: "actions",
      header: <div style={{ textAlign: "center" }}>Action</div>,
      cell: (props) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <button
            style={{
              color: "#46CD80",
              fontSize: "12px",
              lineHeight: "12px",
              fontWeight: 500,
              fontFamily: "Poppins, sans",
              padding: "8px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => handleOpenModal(props.row.original, "Approve")}
          >
            Approve
          </button>
          |
          <button
            style={{
              color: "#FE0000",
              fontSize: "14px",
              lineHeight: "14px",
              fontWeight: 500,
              fontFamily: "Poppins, sans",
              padding: "8px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => handleOpenModal(props.row.original, "Reject")}
          >
            Reject
          </button>
        </div>
      ),
    }),
  ],
};
